<template>
    <div>
        <b-form-row class="mb-2">
            <b-col cols="3">
                <div class="px-2 py-1 bg-light font-weight-bold">
                    {{ masterQuery[index].filterName }}
                </div>
            </b-col>
            <b-col cols="2">
                <b-form-select :options="parameters.options"
                               @change="updateMasterQuery()"
                               v-model="masterQuery[index].filterParameter"
                               size="sm">
                </b-form-select>
            </b-col>

            <b-col>
                <template v-if="inputType == 'input' ">
                    <b-input lazy v-model="masterQuery[index].filterValue"
                             type="text"
                             class="border-color"
                             size="sm">
                    </b-input>
                </template>

                <template v-else-if="inputType == 'datepicker' ">

                    <vc-date-picker mode="date" v-model="masterQuery[index].filterValue" :popover="datePickerProps" :attributes="todaysDot" :timezone="'America/New_York'">
                        <template v-slot="{ inputValue, inputEvents }">
                            <b-input size="sm" v-on="inputProxy(inputEvents,masterQuery[index])" class="w-100" :value="inputValue"></b-input>
                        </template>
                    </vc-date-picker>

                </template>

                <template v-else-if="inputType == 'select' ">
                    <b-form-select v-if="masterQuery[index].filterName == 'Color' "
                                    v-model="masterQuery[index].filterValue"
                                   :options="colorOptions"
                                   size="sm">
                    </b-form-select>
                    <template v-else-if="masterQuery[index].filterName == 'Purity'">
                        <b-form-select
                                       v-model="masterQuery[index].filterValue"
                                       :options="purityOptions"
                                       size="sm">
                        </b-form-select>
                    </template>
                    <b-form-select v-else
                                   v-model="masterQuery[index].filterValue"
                                   :options="options.options"
                                   size="sm">
                    </b-form-select>
                </template>

            </b-col>

            <b-col cols="1" class="d-flex align-items-center">
                <i @click="$emit('removeFilter', index)" class="pointer fa-solid fa-times text-danger"></i>
            </b-col>

        </b-form-row>
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker';
    import moment from 'moment';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import _ from 'lodash';
    export default {
        components: {DateRangePicker},
        name: 'searchFilterItem',
        props: ['index','masterQuery','loadSavedFilter','flagTypes','itemTypes','inventoryTypes','itemClarities','itemClasses', 'users', 'item'],
        data() {
            return {
                todaysDot: [
                    {
                        key: 'today',
                        dot: true,
                        content: 'blue',
                        dates: new Date(),
                    }
                ],
                datePickerProps: {
                    placement: 'bottom',
                    positionFixed: true,
                },
                inventoryType: {},
                metalType: null,
                colorOptions: null,
                purityOptions: {text: 'select', value: null},
                isLoading: false,
                newDate: null,
                dateRange: {
                    startDate: null,
                    endDate: null
                },
                rule_1: ['equals','not equal to','contains','does not contain','starts with', 'ends with'],
                rule_2: ['equals','not equal to','greater than','less than','starts with'],
                rule_3: ['equals','not equal to'],
                rule_4: ['on','before','after'],
            };
        },
        mounted() {

        },
        created() {
            if(this.inputType == 'Select' && this.masterQuery[index].filterValue != null) {
                this.masterQuery[index].filterValue = 0;
            }
            if(this.loadSavedFilter == false && this.inputType == 'select'
                    && this.masterQuery[this.index].filterName != 'Purity'
                    && this.masterQuery[this.index].filterName != 'Color') {
            }
            if(this.masterQuery[this.index].filterValue == null && (this.options && (this.options.selected || this.options.selected === 0))) {
                this.masterQuery[this.index].filterValue = this.options.selected;
            } else if (this.options){
                this.options.selected = this.masterQuery[this.index].filterValue;
            }
            if(this.masterQuery[this.index].filterName == 'Color') {
                this.setColorOptions();
            }

            if(this.masterQuery[this.index].filterName == 'Purity') {
                this.setPurityOptions();
            }

            this.dateRange.startDate = this.date(this.masterQuery[this.index].filterValue);
            this.dateRange.endDate = this.date(this.masterQuery[this.index].filterValue);
        },
        updated: function () {
            this.$nextTick(function () {
                if(this.masterQuery[this.index].filterName == 'Purity') {
                    //this.setPurityOptions();
                }
            });
        },
        methods: {
            inputProxy(proxiable, section) {

                //console.log(proxiable,section);
                proxiable.change = (newValue) => {
                    section.filterValue = new Date(newValue);
                };
                return proxiable;
            },
            clearDate(event) {
                this.newDate = null;
                this.$forceUpdate();
            },
            updateMasterQuery() {
                this.$emit('updateFilter', this.index, this.masterQuery[this.index]);
            },
            date(val) {
                return val ? moment(val).format('MM-DD-YYYY') : '';
            },
            checkForInventoryType() {
                return this.masterQuery.some( el => el.filterName == 'Inventory Type');
            },
            setPurityOptions() {
                let metalType = this.masterQuery.slice().reverse().find(item => item.filterName == 'Metal');
                this.metalType = metalType;
                if(metalType.filterValue == null) {
                    this.purityOptions = this.itemClasses[0].purities.map(item => ({
                                value: item.purity,
                                text: item.purity +' '+ item.purity_type,
                            }));
                } else {
                    let a = this.itemClasses.filter(item => item.id == metalType.filterValue);
                    this.purityOptions = a[0].purities.map(item => ({
                                value: item.purity,
                                text: item.purity +' '+ item.purity_type,
                            }));
                }

            },
            setColorOptions() {
                let inventoryType = this.masterQuery.slice().reverse().find(item => item.filterName == 'Item Type');
                this.inventoryType = inventoryType;
                let itemTypeId = inventoryType.filterValue;
                if(itemTypeId == null) {
                    this.colorOptions =  this.inventoryTypes[0].colors.map( function (item) {
                        return {
                            value: item.id,
                            text: item.name,
                        };
                    });
                } else {
                    let a = this.itemTypes.filter(type => type.id == itemTypeId);
                    this.colorOptions =  this.inventoryTypes[a[0].item_category_id - 1].colors.map( function (item) {
                        return {
                            value: item.id,
                            text: item.name,
                        };
                    });
                }

                this.masterQuery[this.index].filterValue = this.colorOptions[0].value;
            }
        },
        watch: {
            dateRange() {
                this.dateRange.startDate = this.date(this.dateRange.startDate);
                this.masterQuery[this.index].filterValue = this.dateRange.startDate;
            },
            masterQuery() {
                this.dateRange.startDate = this.masterQuery[this.index].filterValue;
                this.dateRange.endDate = this.masterQuery[this.index].filterValue;
                this.updateMasterQuery();
                this.$nextTick(function () {
                    if(this.masterQuery[this.index].filterName == 'Color') {
                        this.setColorOptions();

                    }
                });

            },
            'inventoryType.filterValue': function () {
                this.setColorOptions();
            },
            'metalType.filterValue': function () {
                this.setPurityOptions();
            }
        },
        computed: {
            inputType() {
                switch (this.masterQuery[this.index].filterName) {
                    case 'Tracking Number':
                    case 'Order ID':
                    case 'Customer ID':
                    case 'Email Address':
                    case 'First Name':
                    case 'Last Name':
                    case 'Address 1':
                    case 'Address 2':
                    case 'City':
                    case 'Zip':
                    case 'Offer Total':
                    case 'Total DWT':
                    case 'Phone Number':
                    case 'Notes':
                    case 'ID Number':
                    case 'Inventory ID':
                    case 'Batch ID':
                    case 'Size':
                    case 'Penny Weight (DWT)':
                    case 'Total Value':
                    case 'Campaign By Source':
                    case 'Campaign By Name':
                        return 'input';

                    case 'Date Created':
                    case 'Created On':
                    case 'Payment Process Date':
                    case 'Decline Date':
                    case 'Kit Request Date':
                    case 'Receive Date':
                    case 'Appraisal Date':
                    case 'Offer Ready Date':
                    case 'Accept Date':
                    case 'Reverse Ship Date':
                    case 'Settle Date':
                    case 'Return Date':
                        return 'datepicker';
                    default:
                        return 'select';
                }
            },
            parameters() {
                switch (this.masterQuery[this.index].filterName) {
                    case 'GX Campaign (By CID)':
                    case 'Offer Total':
                    case 'Total DWT':
                    case 'Total Value':
                    case 'Tracking Campaign (By Name)':
                        return {options:this.rule_2};

                    case 'Accept Method':
                    //case 'Account Manager': #TODO what is this?
                    case 'API Account':
                    case 'Batched':
                    case 'Card Signed':
                    case 'Clarity':
                    case 'Color':
                    case 'Contains Melee':
                    case 'Customer Status':
                    case 'Flag':
                    case 'ID Type':
                    case 'Item Type':
                    case 'Inventory Type':
                    case 'Item Status':
                    case 'Metal':
                    case 'Order Status':
                    case 'Stop Workflow':
                    case 'Safe':
                        return {options:this.rule_3};

                    case 'Accept Date':
                    case 'Decline Date':
                    case 'Appraisal Date':
                    case 'Created On':
                    case 'Date Created':
                    case 'Kit Request Date':
                    case 'Offer Ready Date':
                    case 'Payment Process Date':
                    case 'Receive Date':
                    case 'Return Date':
                    case 'Reverse Ship Date':
                    case 'Settle Date':
                        return {options:this.rule_4};

                    case 'Tracking Number':
                    case 'Offer Email Sent':
                    case 'State':
                        return {options:['equals']};

                    default:
                        return {options:this.rule_1};
                }
            },
            options() {
                switch (this.masterQuery[this.index].filterName) {
                    case 'Accept Date':
                    case 'Decline Date':
                    case 'Appraisal Date':
                    case 'Created On':
                    case 'Date Created':
                    case 'Kit Request Date':
                    case 'Offer Ready Date':
                    case 'Payment Process Date':
                    case 'Receive Date':
                    case 'Return Date':
                    case 'Reverse Ship Date':
                    case 'Settle Date':
                        let date = new Date();
                        let year = date.getFullYear();

                        let month = (1 + date.getMonth()).toString();
                        month = month.length > 1 ? month : '0' + month;

                        let day = date.getDate().toString();
                        day = day.length > 1 ? day : '0' + day;
                        return {
                            selected: month + '/' + day + '/' + year
                        };
                    case 'Accept Method':
                        return {
                            selected: null,
                            options:[
                                { value: 'user', text: 'User Accepted'},
                                { value: 'agent', text: 'Agent Accepted'},
                                { value: 'system', text: 'System Accepted'},
                            ]
                        };
                    /*case 'Account Manager': #TODO what is this?
                        let accountManagers = this.users.map(function(item) {
                            return {
                                value: item.id,
                                text: item.name,
                            };
                        });
                        accountManagers = _.sortBy(accountManagers, ['text']);
                        return {
                            selected: 1,
                            options: accountManagers
                        };*/
                    case 'Brand':
                        return {
                            selected: 1,
                            options:[
                                {value:1, text:'Sell Your Gold' },
                                {value:3, text:'Gold Kit' },
                                {value:6, text:'Things We Buy' },
                                {value:5, text:'Recycle Platinum' },
                                {value:4, text:'Out of Your Life' },
                            ],
                        };
                    case 'Offer Email Sent':
                        return {
                            selected: 0,
                            options:[
                                {value:1, text:'Sent' },
                                {value:0, text:'Unsent' },
                            ],
                        };
                    case 'Customer Status':
                        return {
                            selected: 1,
                            options:[
                                {value:1, text:'Active' },
                                {value:2, text:'Banned' },
                            ],
                        };
                    case 'Clarity': {
                        var itemClarities = this.itemClarities.map(function(item) {
                            return {
                                value: item.id,
                                text: item.name,
                            };
                        });
                        return {
                            selected: 1,
                            options: itemClarities
                        };

                    }
//                    case 'Colors':
//                        return {
//                            selected: 0,
//                            options:[
//                                { value:0, text: "Yes" },
//                                { value:1, text: "No" }
//                            ]
//                        };
                    case 'Contains Melee':
                    case 'Stop Workflow':
                    case 'Batched':
                    case 'Card Signed':
                        return {
                            selected: 0,
                            options:[
                                {value: 0, text: 'No'},
                                {value: 1, text: 'Yes'}
                            ]
                        };
                    case 'Flag':
                        var flagOptions = _.filter(this.flagTypes,
                            (flag) => {
                            //either its a order flag or we are on customer filter, never both
                            if(flag.flaggable_type == 'GoldExchange\\Models\\Order' ^ this.item.filterModel == 'customer_flags')
                                return true;
                            }
                        ).map(function(flag) {
                            return {
                                value: flag.id,
                                text: flag.name,
                            };
                        });
                        flagOptions = _.sortBy(flagOptions, ['text']);
                        return {
                            selected: flagOptions[0].id,
                            options: flagOptions
                        };
                    case 'ID Type':
                            return {
                                selected: 'drivers-license',
                                options:[
                                    { value:'state-issued', text: 'State ID'},
                                    { value:'drivers-license', text: 'Drivers License'},
                                    { value:'passport', text: 'Passport'},
                                    { value:'military', text: 'Military ID'},
                                    { value:'picture', text: 'Picture'},
                                ]
                            };

                    case 'Item Type':
                        var itemTypes = this.itemTypes.map(function(item) {
                            return {
                                value: item.id,
                                text: item.name,
                                category_id: item.item_category_id,
                            };
                        });
                        return {
                            selected: 1,
                            options: itemTypes
                        };
                    case 'Inventory Type':
                        var inventoryTypes = this.inventoryTypes.map(function(item) {
                            return {
                                value: item.id,
                                text: item.name,
                            };
                        });
                        return {
                            selected: 1,
                            options: inventoryTypes
                        };
                    case 'Item Status':
                        return {
                            selected: 'melt',
                            options:[
                                { value: 1, text: 'Melt'},
                                { value: 2, text: 'Hold'},
                                { value: 3, text: 'Reverse-ship'},
                                { value: 4, text: 'Returned'},
                                { value: 5, text: 'Batched'},
                                { value: 6, text: 'Exported'},
                            ]
                        };
                    case 'Metal':
                        return {
                            selected: 1,
                            options:[
                                { value: 1, text: 'Gold'},
                                { value: 2, text: 'Gold-Plated'},
                                { value: 3, text: 'Gold-Filed'},
                                { value: 4, text: 'Silver'},
                                { value: 5, text: 'Silver-Plated'},
                                { value: 6, text: 'Platinum'},
                                { value: 7, text: 'Palladium'},
                                { value: 8, text: 'Diamond'},
                                { value: 9, text: 'Melee'},
                                { value: 10, text: 'Dental'},
                                { value: 11, text: 'Other'},
                            ]
                        };
                    case 'Order Status':
                        return {
                            selected: 1,
                            options:[
                                {value: 0,  text: 'Invalid Request'},
                                {value: 1,  text: 'Kit Requested'},
                                {value: 2,  text: 'Kit Shipped'},
                                {value: 3,  text: 'Kit Inbound'},
                                {value: 4,  text: 'Kit Received'},
                                {value: 5,  text: 'Appraisal'},
                                {value: 6,  text: 'Appraisal Hold'},
                                {value: 7,  text: 'Offer Generation'},
                                {value: 8,  text: 'Offer Ready'},
                                {value: 9,  text: 'Offer Accepted'},
                                {value: 10, text: 'Offer Declined'},
                                {value: 11, text: 'Reverse Ship'},
                                {value: 12, text: 'Returned'},
                                {value: 13, text: 'Settled'},
                                {value: 14, text: 'Batched'},
                                {value: 15, text: 'Closed'},
                                {value: 16, text: 'Quality Assurance'},
                            ]
                        };
                    case 'Processed By':
                        var users = this.users.map(function(item) {
                            return {
                                value: item.id,
                                text: item.name,
                            };
                        });
                        users = _.sortBy(users, ['text']);
                        return {
                            selected: 1,
                            options: users
                        };
                    case 'Safe':
                        return {
                            selected: null,
                            options:[
                                {value: 1,  text: 'Pre-Regulatory Hold 1'},
                                {value: 2,  text: 'Pre-Regulatory Hold 2'},
                                {value: 3,  text: 'Regulatory Hold 1'},
                                {value: 4,  text: 'Regulatory Hold 2'},
                                {value: 5,  text: 'Luxury Safe'},
                                {value: 6,  text: 'Inventory Management Room'},
                                {value: 7,  text: 'Processing Floor'},
                                {value: 8,  text: 'Refiner'},
                            ]
                        };
                    case 'State':
                        return {
                            selected: null,
                            options: this.US_STATES_UNFILTERED
                        };

                    default:
                        return null;
                }
            }
        }
    };
</script>


<style>
    .reportrange-text {
        max-height: 28px;
        font-size: 12px !important;
        border-color: #ebeef1 !important;
    }
    .border-color {
        border-color: #ebeef1 !important;
    }
    option:disabled {
        color: lightgray !important;
        text-decoration: line-through;
    }
</style>
